// In your Image component styles.js
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
    container: {
        textAlign: "center",
        padding: "20px 15px", // Reduced padding
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "80px", // Fixed height for consistency
    },
    image: {
        width: "135px",
        height: "auto", // Changed from "100%" to "auto"
        maxHeight: "60px", // Limit maximum height
        objectFit: "contain", // Changed from "cover" to "contain" - this prevents cropping!

        [theme.breakpoints.down("md")]: {
            width: "100px",
            maxHeight: "50px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "91px",
            maxHeight: "45px",
        },
    },
}));